import { Link } from "react-router-dom";

const stats = [
  { value: "1500+", label: "影视作品" },
  { value: "600+", label: "演员资料" },
  { value: "12", label: "内容分类" },
  { value: "每日", label: "资讯更新" },
];

export default function IntroBand() {
  return (
    <section className="max-w-content mx-auto px-4 md:px-6 py-12 md:py-16">
      <div className="rounded-lg bg-primary-950 text-background-50 p-8 md:p-12 grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
        <div>
          <span className="inline-flex items-center gap-2 px-3 h-7 rounded-full bg-primary-800 text-background-200 text-xs">
            <i className="ri-information-line" />
            关于葵司
          </span>
          <h2 className="mt-4 font-heading font-black text-2xl md:text-3xl">
            影视资讯与演员资料大全
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-background-200">
            葵司致力于为影视爱好者、行业从业者与普通观众提供一站式的影视内容服务。我们聚合电影、电视剧、综艺等多元类型的信息，并持续更新演员资料与作品动态，让每一次查询都清晰、便捷。
          </p>
          <div className="mt-6">
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-5 h-11 rounded-md bg-accent-500 text-background-950 text-sm font-medium whitespace-nowrap cursor-pointer hover:bg-accent-400 transition-colors"
            >
              了解更多
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-4">
          {stats.map((s) => (
            <div
              key={s.label}
              className="rounded-lg bg-primary-900 border border-primary-800 p-5"
            >
              <p className="font-heading font-black text-2xl md:text-3xl text-accent-400">
                {s.value}
              </p>
              <p className="mt-1 text-sm text-background-300">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}